import { SkinElement } from "../skin.js";
import { template } from "../../internal/skins/minimal-audio/template.js";
import minimal_skin_default from "../../define/audio/minimal-skin2.js";
import { createShadowStyle } from "@videojs/utils/dom";
//#region src/presets/audio/minimal-skin.ts
/** Packaged Minimal audio UI registered as `<audio-minimal-skin>`. */
var MinimalAudioSkinElement = class extends SkinElement {
	static {
		this.tagName = "audio-minimal-skin";
	}
	static {
		this.styles = createShadowStyle(minimal_skin_default);
	}
	static {
		this.template = template;
	}
};
//#endregion
export { MinimalAudioSkinElement };
